import React from 'react'
import Footer from '../../Components/Footer/Footer'
import Hero from './Hero/Hero'
import TextContent from "./TextContent/TextContent";
import Daans from './Daans/Daans';
import QRCodes from './QRCodes/Qrcodes';
import DonationForm from './Form/DonationForm';


const Support = () => {
  return (
    <div>
      <Hero/>
      <TextContent />
      <Daans />
      <DonationForm />
      <QRCodes />
      <Footer/>
    </div>
  )
}

export default Support
